//ItemManagement.js
import React, { Component } from 'react';
import axios from 'axios';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  TablePagination, CircularProgress, Alert, Button, TextField, InputAdornment
} from '@mui/material';
import { NavLink, Navigate } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';

class ItemManagement extends Component {
  state = {
    customers: [],
    loading: true,
    error: '',
    page: 0,
    rowsPerPage: 5,search: "",
    totalItems: 0,
    itemsPerPageOptions: [5, 10, 20],
  };

  componentDidMount() {
    document.title = "Prep for Sale - Item Management";

    if (localStorage.getItem("DCuserid") == null) {
      this.setState({
        logredirect: true,
        pagename: '/'
      });
      return;
    }

    this.loadCustomerList();
  }

  loadCustomerList = () => {
    const { page, rowsPerPage } = this.state;

    this.setState({ loading: true });

axios.get(`${Serverurl}items/customerlist?page=${page}&limit=${rowsPerPage}&search=${this.state.search}`)
      .then((res) => {
        this.setState({
          customers: res.data.data || [],
          totalItems: res.data.totalItems || 0,
          loading: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ error: 'Failed to fetch customers', loading: false });
      });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.loadCustomerList);
  };

  handleChangeRowsPerPage = (event) => {
    const rows = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: rows, page: 0 }, this.loadCustomerList);
  };
handleSearchChange = (e) => {
  this.setState({ search: e.target.value });
};

handleSearchClick = () => {
  this.setState({ page: 0 }, this.loadCustomerList);
};

  render() {
    if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />;
    }

    if (this.state.loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
          <CircularProgress />
        </Box>
      );
    }

    return (
      <div className="maincontentDiv">
        <Typography pt={2} pb={3} className="contentHeading" variant="h5" gutterBottom>
          Item Management
        </Typography>

        {this.state.error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {this.state.error}
          </Alert>
        )}
<Box sx={{
  display: 'flex',
  flexWrap: 'wrap',
  gap: 2,
  mb: 2,
  alignItems: 'flex-end'
}}>
  <Box className="contentSearch" sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
    <Typography variant="body1" sx={{ mb: 0.5 }}>Name / Email / Phone</Typography>
    <TextField
      variant="outlined"
      value={this.state.search}
      onChange={this.handleSearchChange}
      fullWidth
      size="small"
      placeholder="Search"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <img src={searchIcon} alt="Search" />
          </InputAdornment>
        ),
      }}
    />
  </Box>

  <Box sx={{ display: 'flex', gap: 1 }}>
    <Button
      variant="contained"
      className="frmPrimarybtn"
      onClick={this.handleSearchClick}
    >
      Search
    </Button>
  </Box>
</Box>
        {this.state.customers.length === 0 ? (
          <Typography align="center">No customers found.</Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {this.state.customers.map((cu) => (
                  <TableRow key={cu.cu_id}>
                    <TableCell>{cu.cu_name}</TableCell>
                    <TableCell>{cu.cu_emailid}</TableCell>
                    <TableCell>{cu.cu_phonenumber}</TableCell>
                    <TableCell>
                      <NavLink
						  to={`/ViewItems?id=${cu.cu_id}`}
						  state={{ customer: cu }}
						>
                         <Button
                          variant="contained"
                          size="small"
                          className="frmPrimarybtn"
                        >
                          View
                        </Button>
                      </NavLink>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <TablePagination
              component="div"
              count={this.state.totalItems}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              rowsPerPage={this.state.rowsPerPage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              rowsPerPageOptions={this.state.itemsPerPageOptions}
            />
          </TableContainer>
        )}
      </div>
    );
  }
}

export default ItemManagement;
